module.exports = __webpack_public_path__ + "img/ELECOCITE.0e150268.png";